import { isLargeModelSelector } from 'src/selectors/diagramSnapshot';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

/**
 * Whether the current project's model is large enough to defer the GoJS diagram
 * and default to the headless list view.
 */
export const useIsLargeModel = (): boolean => {
  const { projectId } = useRouterParams();
  return useReduxSelector(isLargeModelSelector(projectId));
};
